import React, { FC } from 'react';

import { Copy } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import clx from 'classnames';
import { useShareLinkCopy } from 'client/hooks/useCopy';

import styles from './TextInputWithCopy.module.scss';

interface Props {
    value: string;
    disabled?: boolean;
}

export const TextInputWithCopy: FC<Props> = ({ value, disabled }) => {
    const { buttonRef, onButtonClick, onCodeClick, textRef } = useShareLinkCopy();

    return (
        <div
            className={clx(
                'g-text-input',
                'g-text-input_view_normal',
                'g-text-input_size_xl',
                'g-text-input_pin_round-round',
                styles.container,
            )}
            onClick={disabled ? undefined : onCodeClick}
        >
            <div className={clx('g-text-input__content', styles.content)}>
                <div
                    className={clx(styles.text, 'g-text-input__control', 'g-text-input__control_type_input')}
                    ref={textRef}
                >
                    {value}
                </div>
                <Button
                    className={styles.button}
                    onClick={onButtonClick}
                    ref={buttonRef}
                    disabled={!value || disabled}
                    view="flat"
                    size="l"
                >
                    <Icon data={Copy} />
                </Button>
            </div>
        </div>
    );
};
